import React from "react";
import {
  KeyValuePairs,
  Modal,
  Button,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import {
  OmsRecordFilter,
  OmsReport,
} from "../../lusca-search-api/generated-src";
import useOmsModalHeight from "../../hooks/useOmsModalHeight";
import { reportTimestamp } from "./OMSReportSchedule";
import OMSSettingsSummary from "./OMSSettingsSummary";

export default function OMSExportReview({
  productLabel,
  report,
  mode,
  filters,
  operation,
  columns,
  allColumns,
  incomplete,
  onBack,
  actions,
}: {
  productLabel: string;
  report: OmsReport;
  mode: "full" | "filtered";
  filters: OmsRecordFilter[];
  operation: "and" | "or";
  columns: string[];
  allColumns: boolean;
  incomplete: number;
  onBack: () => void;
  actions: React.ReactNode;
}) {
  const { height, width, contentRef, titleRef, footerRef } = useOmsModalHeight(
    480,
    840
  );
  return (
    <Modal
      visible
      header={<span ref={titleRef}>Review export settings</span>}
      width={width}
      size="x-large"
      height={height}
      position="top"
      onDismiss={onBack}
      closeAriaLabel="Back to export settings"
      footer={
        <div ref={footerRef} className="oms-report-download__footer">
          <Button onClick={onBack}>Back to settings</Button>
          {actions}
        </div>
      }
    >
      <div ref={contentRef}>
        <SpaceBetween size="l">
          <KeyValuePairs
            columns={2}
            items={[
              { label: "Product", value: productLabel },
              {
                label: "Pinned report refreshed",
                value: (
                  <time dateTime={report.sourceRefreshedAt}>
                    {reportTimestamp(report.sourceRefreshedAt)}
                  </time>
                ),
              },
            ]}
          />
          <OMSSettingsSummary
            report={report}
            mode={mode}
            filters={filters}
            operation={operation}
            columns={columns}
            allColumns={allColumns}
            incomplete={incomplete}
            standalone
          />
        </SpaceBetween>
      </div>
    </Modal>
  );
}
